import { render, staticRenderFns } from "./EditLandingPage.vue?vue&type=template&id=0bff10ac"
import script from "./EditLandingPage.vue?vue&type=script&lang=ts"
export * from "./EditLandingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports